var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"background"},[_c('LoginHeader',{attrs:{"lang":_vm.lang}}),_c('LoginBanner',{attrs:{"lang":_vm.lang}}),_c('LoginMenu',{attrs:{"loginMenu":_vm.loginMenu,"lang":_vm.lang}}),_c('LoginListGame',{attrs:{"loginMenu":_vm.loginMenu,"lang":_vm.lang}}),_c('DialogLogin'),_c('LoginFooter',{attrs:{"lang":_vm.lang}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }